export default "__VITE_ASSET__C1WusTsx__"